import * as React from 'react';

import { replaceElement } from '@lendi-jam/generic-rich-text';
import Table, { type TableAlignment, type TableColumn, type TableRow } from '@lendi-jam/table';
import parse from 'html-react-parser';

import { TableContent, TableItem, TablePrimary } from '#contentTypes/Table';

interface PrismicTableProps {
  component: TableContent;
}

const PrismicTable: React.FC<PrismicTableProps> = ({ component }) => {
  const TablePrimaryData = component.primary;
  const TableItems = component.items;
  type alignmentKeyType = keyof TablePrimary;
  const TableAlignmentArray = Object.keys(TablePrimaryData).reduce((total, primaryKey): TableAlignment[] => {
    const alignmentKey = primaryKey as alignmentKeyType;
    const arr = total;
    if (alignmentKey !== 'table_heading' && alignmentKey !== 'table_subheading') {
      arr.push(TablePrimaryData[alignmentKey]);
    }
    return arr;
  }, [] as TableAlignment[]);
  const Rows = TableItems.map((item) => {
    type itemKeyType = keyof TableItem;
    const parsedItem = Object.keys(item).reduce(
      (total, key): TableRow => {
        const obj = total;
        const itemKey = key as itemKeyType;

        if (itemKey === 'row_variant') {
          obj.type = item[itemKey];
        } else {
          const htmlValue = item[itemKey].html;
          if (htmlValue) {
            const objColumn: TableColumn = {
              value: parse(item[itemKey].html, {
                replace: (domNode) => replaceElement(domNode, 'shade.0'),
              }),
              alignment: TableAlignmentArray[obj.columns.length],
            };
            obj.columns.push(objColumn);
          }
        }
        return obj;
      },
      {
        type: 'row',
        columns: [],
      } as TableRow
    );

    return parsedItem;
  });
  return (
    <Table
      heading={TablePrimaryData.table_heading.text}
      subheading={parse(TablePrimaryData.table_subheading.html, {
        replace: (domNode) => replaceElement(domNode, 'shade.0', 'xxs'),
      })}
      rows={Rows}
    />
  );
};

export default PrismicTable;
